import { createAction, props } from '@ngrx/store';
import { PollConfig, PollStatusEnum } from '../../models';

export const startPolling = createAction('[Polling] Start New Poll', props<{ poll: PollConfig }>());

export const continueOngoingPoll = createAction('[Polling] Continue Ongoing Poll', props<{ poll: PollConfig }>());

export const removePoll = createAction('[Polling] Remove Poll', props<{ id: number }>());

export const pollAction = createAction('[Polling] Poll', props<{ poll: PollConfig }>());

export const pollingComplete = createAction('[Polling] Polling Complete', props<{ id: number }>());

export const pollInitialCallError = createAction('[Polling] Initial Call Error', props<{ id: number }>());

export const pollStatusCallError = createAction('[Polling] Status Call Error', props<{ id: number }>());

export const pollStatusCallScoringInProgressError = createAction('[Polling] Status Call Scoring Ongoing Error', props<{ id: number }>());

export const updatePollStatus = createAction('[Polling] Update Poll Status', props<{ id: number; status: PollStatusEnum }>());

export const updateExtractId = createAction('[Polling] Update Extract Id', props<{ id: number; extractId: string | undefined }>());

export const continuePollingSuccess = createAction('[Polling] Continue Polling Success', props<{ response: any; poll: PollConfig }>());

export const userCancel = createAction('[Polling] Set userCancelled to true', props<{ id: number }>());
